const formatter = new Intl.DateTimeFormat("en-CA", {
  timeZone:"America/Sao_Paulo", hour:"2-digit", hourCycle:"h23",
});
export function isNightTime(value = Date.now()) {
  const hour = Number(formatter.format(new Date(value)));
  return hour >= 22 || hour < 8;
}

export function createNightActivity({
  document:doc, window:win, now = Date.now, idleMs = 2 * 60 * 1000,
  setInterval:setTimer = setInterval, clearInterval:clearTimer = clearInterval,
}) {
  let lastInput = now(), stopped = false;
  const listeners = new Set();
  const state = () => {
    const night = isNightTime(now()), visible = doc.visibilityState !== "hidden";
    const idle = now() - lastInput >= idleMs;
    return { night, idle, canRefreshDisplay:visible && !idle,
      canRefresh:visible && (!night || !idle),
      canListen:!night || (visible && !idle) };
  };
  let previous = state();
  function publish() {
    if (stopped) return;
    const next = state();
    if (next.canRefresh !== previous.canRefresh || next.canListen !== previous.canListen
      || next.night !== previous.night || next.idle !== previous.idle) {
      previous = next;
      for (const listener of listeners) listener(next);
    }
  }
  const input = () => { lastInput = now(); publish(); };
  const events = ["pointerdown", "pointermove", "keydown", "touchstart", "wheel"];
  events.forEach(event => win.addEventListener(event, input, { passive:true }));
  doc.addEventListener("visibilitychange", publish);
  const timer = setTimer(publish, 15000); // Local clock only, no network request.
  return {
    state,
    subscribe(listener) { listeners.add(listener); return () => listeners.delete(listener); },
    stop() {
      stopped = true; clearTimer(timer); listeners.clear();
      events.forEach(event => win.removeEventListener(event, input));
      doc.removeEventListener("visibilitychange", publish);
    },
  };
}
let browserActivity;
function activity() {
  if (typeof document === "undefined" || typeof window === "undefined") return null;
  browserActivity ||= createNightActivity({ document, window });
  return browserActivity;
}
export const mayAutoRefresh = () => activity()?.state().canRefresh ?? true;
// Opt-in for non-operational display refreshes only. Message delivery,
// notifications, transfers and the opened chat retain their existing policy.
export const mayRefreshDisplay = () => activity()?.state().canRefreshDisplay ?? true;
export const watchBrowserActivity = listener => activity()?.subscribe(listener) || (() => {});

export function watchNightValue(subscribe, args, tracker = activity()) {
  if (!tracker) return subscribe(...args);
  let unsubscribe = null, stopped = false;
  function reconcile() {
    if (stopped) return;
    if (tracker.state().canListen && !unsubscribe) unsubscribe = subscribe(...args);
    else if (!tracker.state().canListen && unsubscribe) {
      unsubscribe(); unsubscribe = null;
    }
  }
  const unwatch = tracker.subscribe(reconcile);
  reconcile();
  return () => { stopped = true; unwatch(); unsubscribe?.(); unsubscribe = null; };
}
